<template>
  <div>
    <b-field
      label="生年月日"
      :type="isAdult ? '' : 'is-danger'"
      :message="isAdult ? '' : '十八歳以下でのご利用はできません'"
    >
      年齢確認に必要なため、入力してください
      <b-datepicker
        v-model="birthDate"
        locale="ja-JP"
        placeholder="Click to select..."
        icon="calendar-today"
        trap-focus
      />
    </b-field>
    <div class="policy">
      <b-field label="利用規約等への同意">
        <b-checkbox v-model="agreePolicies">
          <router-link
            to="/user-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            <u>利用規約</u>
          </router-link>
          と
          <router-link
            to="/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            <u>プライバシーポリシー</u>
          </router-link>
          に同意の上、登録してください。
        </b-checkbox>
      </b-field>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'QualificationConfirmation',
  props: ['value'],
  computed: {
    // hide props
    birthDate: {
      get() {
        return this.value.birthDate;
      },
      set(birthDate) {
        this.updateValue({ birthDate });
      }
    },
    agreePolicies: {
      get() {
        return this.value.agreePolicies;
      },
      set(agreePolicies) {
        this.updateValue({ agreePolicies });
      }
    },
    // calculate new property
    isAdult() {
      if (this.birthDate === null) {
        return true;
      }
      return moment().subtract(18, 'years').isAfter(this.birthDate);
    },
    // calculate and notify parent of new property
    isValid() {
      return this.isAdult && this.agreePolicies;
    }
  },
  watch: {
    // calculate and notify parent of new property
    isValid: {
      handler(isValid) {
        this.updateValue({ isValid });
      },
      immediate: true
    }
  },
  methods: {
    updateValue(diff) {
      let newValue = { ...this.value, ...diff };
      this.$emit('input', newValue);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/signup-email.scss';
</style>
